import * as immu from 'object-path-immutable'
import { pubmed } from './pubmed'
import * as elastic from '../data-elastic'

// --------------------------------------------
// Always refresh rules based on the available
// drugs in store
// --------------------------------------------
export function rules() {

  return async ( dispatch, getState, api ) => {

    // Get current drugs
    const { xeon } = getState()
    const ids = Object.keys( xeon.drugs )
    const rules = await dispatch( elastic.rulesByIds( ids ) )

    // Always reset rules for now
    dispatch( { type: "xeon.rules", data: rules } )

    // Refresh literature if necessary
    return dispatch( pubmed() )

  }
}